import { MultiAnswerString } from "./MultiAnswerString"
import type { IMultiAnswerProps } from "./types"

export function MultiAnswerComments({ question, answers }: IMultiAnswerProps) {
  if (!question.is_commentable || question.type == "string") return null

  answers = answers.filter((a) => a.comment && a.comment.length > 0)
  if (answers.length === 0) return null

  return <MultiAnswerString question={question} answers={answers} />
}
